import React, {useState} from 'react';
import { useForm } from 'react-hook-form';
import ReCAPTCHA from "react-google-recaptcha";
import CONFIG from '../_config.js';
import '../styles/_form.scss';

const GetQuote = (props) => {   
     
    const { register, handleSubmit, errors } = useForm();
    const [isValid, setValid] = useState(false);

    const onChangeHandler = (e) => {
        var _target = e.target;
        var _targetFieldset = _target.parentNode;
        _target.value !== '' ? _targetFieldset.classList.add('text-in') : _targetFieldset.classList.remove('text-in');               
    }
    function onChange(value) {            
        if(value){
            setValid(true);
        }else{
            alert("Error Verifying reCAPTCHA, please try again.");
        }   
    }
    const onSubmit = data => {
        delete data.upload_resume;
        var fileToUpload = JSON.stringify(data.upload_resume);        
        var dataToSend = JSON.stringify(data);
        var formData = {dataToSend, fileToUpload};
        
        if(isValid){
            fetch(CONFIG.career, {
                method: 'POST',
                body: formData,
            }).then(() => alert("Successful"))
            .catch(() => alert("There was an error, please try again"));
        }else{
            alert("Please Verify reCAPTCHA.");
        }      
    };
    return(
        <div className="GrayBg careerForm">
            <div className="innerBox lg">
                <div className="formHeader">
                    <h3>Time to bring <br className="only-mobile"/>your A game</h3>
                    <p>Check out our open positions</p>
                </div>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <fieldset className="s-full mb0">
                        <h6>Contact Information</h6>
                    </fieldset>
                    <fieldset className={errors.fullname && "error"}>  
                        <label htmlFor="fullname">Full Name *</label>  
                        <input type="text" id="fullname" name="fullname" ref={register({ required: true })} onChange={onChangeHandler}/>
                        <span></span>  
                        {errors.fullname && <p>This field is required.</p> }                                          
                    </fieldset>
                    <fieldset className={errors.mobile && "error"}>
                        <label htmlFor="mobile">Mobile *</label>
                        <input type="tel" id="mobile" name="mobile" ref={register({required: true, minLength: 10})} onChange={onChangeHandler} />
                        <span></span>                        
                        {errors.mobile && errors.mobile.type === "required" &&  <p role="alert">This field is required.</p> }
                        {errors.mobile && errors.mobile.type === "minLength" &&  <p role="alert">Minlength for the field is 10 characters</p> }
                    </fieldset>
                    <fieldset className={errors.email && "error"}>
                        <label htmlFor="email">Email *</label>
                        <input type="text" id="email" name="email" ref={register({ required: true, pattern: /^\S+@\S+$/i})} onChange={onChangeHandler} />
                        <span></span>                        
                        {errors.email && errors.email.type === "required" &&  <p role="alert">This field is required.</p> }
                        {errors.email && errors.email.type === "pattern" &&  <p role="alert">Please enter a valid email address</p> }
                    </fieldset>
                    <fieldset className={errors.address && "error"}>
                        <label htmlFor="address">Address *</label>
                        <input type="text" id="address" name="address" ref={register({ required: true})} onChange={onChangeHandler} />
                        <span></span>                        
                        {errors.address && <p>This field is required.</p> }
                    </fieldset>                    
                    <fieldset className={errors.city && "error"}>
                        <label htmlFor="city">City *</label>
                        <input type="text" id="city" name="city" ref={register({ required: true})} onChange={onChangeHandler} />  
                        <span></span>
                        {errors.city && <p>This field is required.</p> }
                    </fieldset>
                    <fieldset className={errors.state && "error"}>
                        <label htmlFor="state">State *</label>
                        <input type="text" id="state" name="state" ref={register({ required: true})} onChange={onChangeHandler} /> 
                        <span></span>
                        {errors.state && <p>This field is required.</p> }
                    </fieldset>
                    <fieldset className={errors.country && "error"}>
                        <label htmlFor="country">Country *</label>
                        <input type="text" id="country" name="country" ref={register({ required: true})} onChange={onChangeHandler} />
                        <span></span>
                        {errors.country && <p>This field is required.</p> }
                    </fieldset>
                    <fieldset className={errors.postcode && "error"}>
                        <label htmlFor="postalCode">Postal Code</label>
                        <input type="text" id="postalCode" name="postcode" ref={register({ required: true})} onChange={onChangeHandler} />
                        <span></span>                        
                        {errors.postcode && <p>This field is required.</p> }
                    </fieldset>
                    <fieldset className={errors.position_applied && "error"}>
                        <select name="position_applied" ref={register({ required: true })}>
                            <option value="">Position Applied For</option>
                            <option value="Android Developer">Android Developer</option>
                            <option value="Frontend Developer">Frontend Developer</option>
                            <option value="IOS Developer">IOS Developer</option>
                            <option value="NodeJS Developer">NodeJS Developer</option>
                            <option value="Personal Assistant to Management">Personal Assistant to Management</option>
                            <option value="PHP Developer">PHP Developer</option>
                            <option value="Project Manager">Project Manager</option>
                            <option value="Python Developer">Python Developer</option>
                            <option value="ROR Developer">ROR Developer</option>
                            <option value="Others">Others</option>                           
                        </select>
                        <span></span>
                        {errors.position_applied && <p>This field is required.</p> }
                    </fieldset>
                    <fieldset className={errors.total_exp && "error"}>
                        <select name="total_exp" ref={register({ required: true })}>
                            <option value="">Total Experience</option>
                            <option value="1+">1+</option>
                            <option value="2+">2+</option>
                            <option value="3+">3+</option>                       
                        </select>
                        <span></span>
                        {errors.total_exp && <p>This field is required.</p> }
                    </fieldset>
                    <fieldset className="s-full mt15">
                        <h6>Have you interviewed with us before:</h6>
                        <div className="options">
                            <label><input type="radio" name="interview_before" value="Yes" ref={register} />Yes</label>
                            <label><input type="radio" name="interview_before" value="No" ref={register} />No</label>
                        </div>                        
                    </fieldset>
                    <fieldset className="s-full">
                        <h6>Upload Resume</h6>
                        <div className="uploadFile"> 
                            <input name="upload_resume" type="file" id="resume_file" accept=".pdf,.doc,.docx,.txt" ref={register} />                           
                        </div>                        
                    </fieldset>
                    <fieldset>
                        <ReCAPTCHA
                            sitekey={CONFIG.recaptchaSiteKey}
                            onChange={onChange}
                        />
                        <br/>
                        <input type="submit" className="btn pill quote grad-orange full" value="GET A QUOTE" />
                    </fieldset>
                </form>
            </div>            
        </div>
    )
}

export default GetQuote;